module.exports = __webpack_public_path__ + "static/media/worry.d6e84845.png";